export enum OperadorRegraEnum {
    IGUAL = 'IGUAL',
    DIFERENTE = 'DIFERENTE',
    MAIOR = 'MAIOR',
    MENOR = 'MENOR',
    MAIOR_OU_IGUAL = 'MAIOR_OU_IGUAL',
    MENOR_OU_IGUAL = 'MENOR_OU_IGUAL',
}
